/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-02 14:55:45
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { TextStyle, Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { showChatbox } from 'src/integrations/chatbox';
import UpgradingStatusModal from './upgrading-status-modal';
import SwitchVersionModal from './switch-version-modal';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { URL } from 'src/constants/links';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';

type Props = {
  onDismiss: Function,
  onSwitchNew: Function,
  loading: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {
  activeUpgradeModal: boolean,
  activeUpgradingModal: boolean
};

// DONE
class WarningBannerUpgrade extends Component<ComposedProps, State> {
  state = {
    activeUpgradeModal: false,
    activeUpgradingModal: false
  };

  handleLearnMore = () => {
    window.open(URL['UpgradeNewVersion'], '_blank');
  };

  openChatBox = () => {
    showChatbox();
  };

  render() {
    const { tenantApp } = this.props;
    const { activeUpgradeModal, activeUpgradingModal } = this.state;
    const { migrateStatus, i18n } = this.props;
    const isFreemium = isFreemiumPlan(tenantApp);

    return (
      <div className="BC-Search__WarningBannerUpgrade">
        <Banner
          title={i18n.translate('AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.title')}
          status="warning"
          action={{
            content: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.action')}
              </TextStyle>
            ),
            onAction: () => this.toggleModal('activeUpgradeModal'),
            loading: migrateStatus === 'running'
          }}
          secondaryAction={{
            content: i18n.translate('AdminHTML.Common.Action.learnMore'),
            onAction: () => this.handleLearnMore()
          }}>
          <p>
            {i18n.translate('AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content01', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content01_t'
                  )}
                </TextStyle>
              ),
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content01_t1'
                  )}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content01_t2'
                  )}
                </TextStyle>
              ),
              t3: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content01_t3'
                  )}
                </TextStyle>
              )
            })}
          </p>
          <p>{i18n.translate('AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content02')}</p>
          {!isFreemium && (
            <p>
              {i18n.translate('AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content03', {
                t: (
                  <u onClick={() => this.openChatBox()} style={{ cursor: 'pointer' }}>
                    {i18n.translate(
                      'AdminHTML.Common.WarningBannerUpgradeSearchNewVersion.content03_t'
                    )}
                  </u>
                )
              })}
            </p>
          )}
        </Banner>
        <SwitchVersionModal
          active={activeUpgradeModal}
          handleCancel={() => this.toggleModal('activeUpgradeModal')}
          handleUpgrade={this.handleUpgrade}
        />
        <UpgradingStatusModal
          active={activeUpgradingModal}
          handleCancel={() => this.toggleModal('activeUpgradingModal')}
        />
      </div>
    );
  }

  toggleContent = step => {
    this.setState({ step });
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  handleUpgrade = () => {
    // Call api migrate data merchandising + search to new version
    this.props.migrateNewFeatureV2().then(response => {
      const { type = '' } = response;
      if (type === 'MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS') {
        this.setState({ activeUpgradeModal: false, activeUpgradingModal: true });
      } else {
        this.setState({ activeUpgradeModal: false });
      }
      setTimeout(() => {
        this.props.getStatusMigrate();
      }, 3000);
    });
  };

  goToMerchandisingPage = () => {
    history.push(routes.merchandising.view());
    // Call api enable feature flag but not migrate data
  };
}

const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state, 'oauth.tenantApp', {})
  };
};

export default withI18n()(connect(mapStateToProps)(WarningBannerUpgrade));
